import { ResourceClient, type HttpClient } from "@dl/web-core-js/api";

/**
 * The reference data a lot's page picks from: Terrebonne's shelves and the
 * reasons parts are scrapped. Maintained on the Shop floor setup page.
 */

/** A place inside a warehouse (a Terrebonne shelf), with the lot waiting on it, if any. */
export interface StorageLocationDTO {
  id: number;
  warehouse_id: number;
  warehouse_code?: string | null;
  code: string;
  name: string | null;
  position: number;
  is_active: boolean;
  /** The lot packing or packed on it, if any. */
  production_order_id?: number | null;
  production_order_number?: number | null;
}

export interface ScrapReasonDTO {
  id: number;
  code: string;
  name: string;
  name_fr: string;
  position: number;
  is_active: boolean;
}

export class StorageLocationClient extends ResourceClient<StorageLocationDTO> {
  constructor(http: HttpClient) {
    super(http, "/manufacturing/storage-location");
  }

  /** Active shelves of a warehouse (NEXCA: Terrebonne's), in shelf order. */
  ofWarehouse(warehouseCode: string): Promise<StorageLocationDTO[]> {
    return this.find({
      page: 0,
      size: 500,
      filters: { warehouse_code: [warehouseCode], is_active: ["true"] },
    }).then((page) => [...page.content].sort((a, b) => a.position - b.position || a.code.localeCompare(b.code, undefined, { numeric: true })));
  }
}

export class ScrapReasonClient extends ResourceClient<ScrapReasonDTO> {
  constructor(http: HttpClient) {
    super(http, "/production/scrap-reason");
  }

  active(): Promise<ScrapReasonDTO[]> {
    return this.find({ page: 0, size: 200, filters: { is_active: ["true"] } }).then((page) =>
      [...page.content].sort((a, b) => a.position - b.position),
    );
  }
}

/** Terrebonne's finished-goods warehouse, whose shelves a completed product lot sits on. */
export const TERREBONNE_SHELF_WAREHOUSE = "NEXCA";
